
export default {
  props: {
    system: {
      type: String
    }
  },
  computed: {
    ctrLetter () {
      return this.system === 'Windows' ? 'Ctrl' : 'Cmd'
    }
  }
}
